import React, { useState } from "react";

const plans = [
  { title: "Basic", price: "$10", devices: "4 Devices", duration: "30 Days" },
  { title: "Premium", price: "$100", devices: "4 Devices", duration: "1 Year" },
];

const PricingPlans = () => {
    const [selectedIndex, setSelectedIndex] = useState(null);

    const handleClick = (index) => {
      setSelectedIndex(index);
      setTimeout(() => {
        setSelectedIndex(null);
      }, 3000);
    };

  return (
    <section style={styles.section}>
      <h2 style={styles.heading}>Choose Your Plan</h2>
      <div style={styles.grid}>
        {plans.map((plan, i) => (
          <div
            key={i}
            className="plan-card"
            style={styles.card}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = styles.cardHover.transform;
              e.currentTarget.style.boxShadow = styles.cardHover.boxShadow;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow = styles.card.boxShadow;
            }}
            onClick={() => handleClick(i)}
          >
            {selectedIndex === i ? (
              <p style={{ color: "#018ae0", fontWeight: "bold" }}>See How to Pay Section Below</p>
              
            ) : (
              <>
                <h3>{plan.title}</h3>
                <p style={styles.price}>{plan.price}</p>
                <p>{plan.devices}</p>
                <p>{plan.duration}</p>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default PricingPlans;

const styles = {
  section: {
    padding: "2rem",
    backgroundColor: "#0d0d0d",
    color: "#fff",
    textAlign: "center",
  },
  heading: {
    fontSize: "2rem",
    marginBottom: "2rem",
  },
  grid: {
    display: "flex",
    gap: "2rem",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  card: {
    backgroundColor: "#1e1e1e",
    borderRadius: "12px",
    padding: "2rem",
    width: "260px",
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.3)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "pointer",
  },
  cardHover: {
    transform: "scale(1.03)",
    boxShadow: "0 0 30px #018ae0",
  },
  price: {
    fontSize: "1.5rem",
    color: "#018ae0",
    margin: "0.5rem 0",
  },
};
